<template>
  <v-dialog persistent v-model="isShowModal" max-width="800px">
    <v-card>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs12>
              <h3 class="text-xs-center py-2 my-2">
                Listing update data
              </h3>
            </v-flex>
            <v-flex xs12>
              <v-layout row class="mb-3">
                <v-flex xs4 class="text-xs-center py-2">
                  <strong>Creation Date: </strong>
                  {{getDate(data.creationDate)}}
                </v-flex>
                <v-flex xs4 class="text-xs-center py-2">
                  <strong>Date of Last Edit: </strong>
                  {{getDate(data.updateDate)}}
                </v-flex>
                <v-flex xs4 class="text-xs-center py-2">
                  <strong>Date of approve: </strong>
                  {{getDate(data.approveDate)}}
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 class="text-xs-center">
              <strong>Last admin who edited: </strong>
              {{getAdminByPackage(data.lastUpdatedAdminId)}}
            </v-flex>
            <v-flex xs12 class="text-xs-center py-2">
              <v-btn
                color="blue darken-1"
                flat="flat"
                @click="closeModal()"
              >
                close
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'DataUpdateModal',
    props: {
      isShow: {
        default: false,
        required: true,
        type: Boolean
      },
      data: {
        required: true,
        type: Object
      }
    },
    data () {
      return {
        isShowModal: false
      }
    },
    computed: {
      ...mapGetters([
        'getUsersListWithCurrentUser'
      ])
    },
    watch: {
      isShow: {
        handler () {
          this.isShowModal = this.isShow
        },
        immediate: true,
      },
      isShowModal (val) {
        if (!val) this.closeModal()
      }
    },
    methods: {
      ...mapActions([
        'fetchUsers'
      ]),
      getDate (date) {
        const d = new Date(date)
        const month = d.getMonth() + 1
        const day = d.getDate()
        const year = d.getUTCFullYear()
        return `${month} / ${day} / ${year}`
      },
      getAdminByPackage (lastModifiedAdminId) {
        if (this.getUsersListWithCurrentUser.length === 0) return
        if (lastModifiedAdminId) {
          const adminThatDidEditLast = this.getUsersListWithCurrentUser.find(user => user.id === lastModifiedAdminId)
          return adminThatDidEditLast ? adminThatDidEditLast.userName : ''
        }
        return ''
      },
      closeModal () {
        this.$emit('close')
      }
    },
    created () {
      this.fetchUsers({ page: 0, itemsOnPage: 999999 })
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/pages/Listing/ListingList/dataUpdate.vue